import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ================================
   ACTION TYPES
================================ */
export const FETCH_KITCHENDINING_SURVEY_LIST_REQUEST =
  "FETCH_KITCHENDINING_SURVEY_LIST_REQUEST";
export const FETCH_KITCHENDINING_SURVEY_LIST_SUCCESS =
  "FETCH_KITCHENDINING_SURVEY_LIST_SUCCESS";
export const FETCH_KITCHENDINING_SURVEY_LIST_FAILURE =
  "FETCH_KITCHENDINING_SURVEY_LIST_FAILURE";

export const FETCH_KITCHENDINING_SURVEY_DETAIL_REQUEST =
  "FETCH_KITCHENDINING_SURVEY_DETAIL_REQUEST";
export const FETCH_KITCHENDINING_SURVEY_DETAIL_SUCCESS =
  "FETCH_KITCHENDINING_SURVEY_DETAIL_SUCCESS";
export const FETCH_KITCHENDINING_SURVEY_DETAIL_FAILURE =
  "FETCH_KITCHENDINING_SURVEY_DETAIL_FAILURE";

export const FETCH_KITCHENDINING_USER_SURVEY_LIST_REQUEST =
  "FETCH_KITCHENDINING_USER_SURVEY_LIST_REQUEST";
export const FETCH_KITCHENDINING_USER_SURVEY_LIST_SUCCESS =
  "FETCH_KITCHENDINING_USER_SURVEY_LIST_SUCCESS";
export const FETCH_KITCHENDINING_USER_SURVEY_LIST_FAILURE =
  "FETCH_KITCHENDINING_USER_SURVEY_LIST_FAILURE";

/* ================================
   USER SUBMITTED SURVEYS
   /kitchendining/usersurveyList
================================ */
export const fetchKitchenDiningUserSurveyList = () => async (dispatch) => {
  dispatch({ type: FETCH_KITCHENDINING_USER_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/kitchendining/usersurveyList`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_KITCHENDINING_USER_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_KITCHENDINING_USER_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch kitchen-dining user surveys");
    throw error;
  }
};

/* ================================
   SURVEY DETAIL
   /user-survey/kitchendining/:id
================================ */
export const fetchKitchenDiningSurveyDetail =
  (surveyId) => async (dispatch) => {
    dispatch({ type: FETCH_KITCHENDINING_SURVEY_DETAIL_REQUEST });

    try {
      const res = await axios.get(
        `${BASE_URL}/api/maa_canteen/user-survey/kitchendining/${surveyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );

      dispatch({
        type: FETCH_KITCHENDINING_SURVEY_DETAIL_SUCCESS,
        payload: res.data.data,
      });

      return res.data.data;
    } catch (error) {
      dispatch({
        type: FETCH_KITCHENDINING_SURVEY_DETAIL_FAILURE,
        payload: error.message,
      });

      toast.error("Failed to fetch kitchen-dining survey detail");
      throw error;
    }
  };

/* ================================
   SURVEY ID LIST (Updated to accept params)
   /user-survey-list/kitchendining
================================ */
export const fetchKitchenDiningSurveyList = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_KITCHENDINING_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/user-survey-list/kitchendining`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
        params: params // Pass parameters like canteen_id
      }
    );

    dispatch({
      type: FETCH_KITCHENDINING_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_KITCHENDINING_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch kitchen-dining survey list");
    throw error;
  }
};